import { Container } from "./Container";
import { mixin } from "../utils/mixin";
import { DirectContainerMixin, getDirectType } from "./direct";
/**
 * Allows direct child mutations.
 * Disables vue vdom patching.
 */
export class DirectContainer extends Container {
    create(nodeType) {
        const directType = getDirectType(nodeType);
        return new directType(this.stage);
    }
}
mixin(DirectContainer, DirectContainerMixin);
//# sourceMappingURL=DirectContainer.js.map